import { store } from "../../../store";

export default {
  routes: [],

  dialogs: [
    {
      name: "sales-team-view",
      path: "/sales-teams/:teamID/view",
      meta: {
        auth: () => store.state.main.user.isEmployee,
      },
      component: () => import("../../../dialogs/admin/SalesTeamView"),
    },
  ],
};
